<template>
  <div>
    <el-table
        :data="tableData"
        size="mini"
        fixed
        :height="tableHeight"
        :max-height="tableHeight"
        header-row-class-name="tableTH"
        :row-class-name="tableRowClassName"
        width="100%"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
    >
      <template v-for="(item, index) in tableLabel">
        <el-table-column :prop="item.prop" :label="item.label" :key="index" v-if="item.width && item.label !== '操作'"
                         :width="item.width" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column :label="item.label" :key="index" v-else-if="item.label == '操作'"
                         :width="item.width" :fixed="fixed">
          <!--          fixed="right"-->
          <template slot-scope="scope">
            <template v-if="slotNum === 1">
              <div
                  class="btnHandle"
                  @click="caozuoHandle(scope.row)"
                  type="text"
                  size="small">
                <slot name="btnText"></slot>
              </div>
            </template>
            <template v-if="slotNum === 2">
              <div
                  style="width:70px;display: inline-block;margin-right: 15px;"
                  class="btnHandle"
                  @click="caozuoHandle(scope.row,'设备明细')"
                  type="text"
                  size="small">
                <slot name="btnText"></slot>
              </div>
              <div
                  style="width:70px;display: inline-block"
                  class="btnHandle"
                  @click="caozuoHandle(scope.row,'报警记录')"
                  type="text"
                  size="small">
                <slot name="btnText2"></slot>
              </div>
            </template>

          </template>
        </el-table-column>
        <el-table-column :prop="item.prop" :label="item.label" :key="index" v-else
                         :show-overflow-tooltip="true"></el-table-column>
      </template>
      <p slot="append" style="text-align:center;" v-loading="loading"><a href="javascript:;" @click="getMore"
                                                                         class="blue01" v-if="moreState && tableData.length != 0">加载更多</a></p>
    </el-table>
  </div>
</template>

<script>
/**
 * 页面中的共用的table组件
 * 配置项：表头：tableLabel
 *       表数据：tableData
 */
export default {
  name: 'TableList',
  props: {
    tableLabel: { //表头
      type: Array
    },
    tableData: { //表格数据
      type: Array
    },
    loading: { //loading状态
      type: Boolean
    },
    tableHeight: {
      type: String
    },
    fixed: {
      type: [String, Boolean],
      default: false
    },
    moreState:{
      type:Boolean,
      default:true
    },
    slotNum: {
      type: Number,
      default: 1
    },
  },
  data() {
    return {
      helloWord: 'Hello Word'
    }
  },
  methods: {
    tableRowClassName({row, rowIndex}) {
      if (rowIndex % 2 === 0) {
        return 'rowOne';
      }
      return '';
    },
    caozuoHandle(row, type) {
      //如果是视频表格的操作点击 把摄像头的登录信息存储到session里使用
      if (row.cameraIp && row.cameraUserName && row.cameraUserPwd) {
        let ip_port = row.cameraIp.split('//')[1].split(':');//[ip,port]
        let item = {
          szIP: ip_port[0],
          szPort: ip_port[1],
          szUsername: row.cameraUserName,
          szPassword: row.cameraUserPwd,
        }
        sessionStorage.setItem('camerInfo', JSON.stringify(item))
        let videoItemInfo2 = sessionStorage.getItem('camerInfo') || ''
      }
      this.$emit('childHandle', row, type)
    },
    // 加载更多的方法
    getMore() {
      this.$emit('tableGetMore')
    },
  }
}
</script>

<style scoped>
.btnHandle {
  cursor: pointer;
  height: 26px;
  box-shadow: 0px 0px 10px 0px #60F0FF;
  border-radius: 2px;
  border: 1px solid #60F0FF;
  text-align: center;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #60F0FF;
}

/deep/ .el-table td, /deep/ .el-table th.is-leaf {
  background: #030E43;
  color: #fff;
  border: 0;
}

.tableTH {

}

/deep/ .el-table .rowOne td {
  background: #060C30;
}

/deep/ .el-table .rowTwo td {
  background: #f0f9eb;
}

/deep/ .el-table, .el-table__expanded-cell {
  background-color: transparent;
}

/deep/ .el-table::before {
  height: 0;
}

/deep/ .el-table td.gutter, /deep/ .el-table th.gutter {
  background: transparent;
}

/deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
  background: #fff;
  color: #333;
}

/deep/ .el-table__fixed-right-patch {
  background-color: #030E43;
  border: 0;
}

/deep/ .el-table__fixed-right::before {
  height: 0;
}
</style>
